module.exports = __webpack_public_path__ + "static/media/carrier-corp-logo.d42f51dd.jpg";